/*eslint-disable */
export default {
  name: 'welcome-popup',
  components: {},
  props: [],
  data () {
    return {

    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {

  }
}
